import { Skeleton } from '@mui/material';

const SkeletonTable = ({ columns, rows=10 }) => {
    let columnsWithoutId = columns - 1;
    if (columnsWithoutId < 1) {
        columnsWithoutId = 1;
    }
    return (
        <>
            {Array.from({ length: rows }).map((_, index) => (
                <tr key={index}>
                    {Array.from({ length: columnsWithoutId }).map((_, index) => (
                        <td key={index}>
                            <Skeleton variant="text" width="100%" height={20} />
                        </td>
                    ))}
                </tr>
            ))}
        </>
    );
}

export default SkeletonTable;